var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.61,
    height: 10.61
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54 5.3l3.81-3.8a.88.88 0 000-1.24.86.86 0 00-1.24 0L5.3 4.06 1.5.26a.86.86 0 00-1.24 0 .86.86 0 000 1.24l3.8 3.8-3.8 3.81a.86.86 0 000 1.24.87.87 0 00.62.26.89.89 0 00.62-.26l3.8-3.81 3.81 3.81a.88.88 0 101.24-1.24z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC42MSIgaGVpZ2h0PSIxMC42MSIgdmlld0JveD0iMCAwIDEwLjYxIDEwLjYxIj4KICA8cGF0aCBkPSJNNi41NCw1LjNsMy44MS0zLjhhLjg4Ljg4LDAsMCwwLDAtMS4yNC44Ni44NiwwLDAsMC0xLjI0LDBMNS4zLDQuMDYsMS41LjI2QS44Ni44NiwwLDAsMCwuMjYuMjZhLjg2Ljg2LDAsMCwwLDAsMS4yNGwzLjgsMy44TC4yNiw5LjExYS44Ni44NiwwLDAsMCwwLDEuMjQuODcuODcsMCwwLDAsLjYyLjI2Ljg5Ljg5LDAsMCwwLC42Mi0uMjZMNS4zLDYuNTRsMy44MSwzLjgxYS44OC44OCwwLDEsMCwxLjI0LTEuMjRaIi8+Cjwvc3ZnPgo=";
export { SvgX as ReactComponent };